
export default {
  props: {
    title: {
      type: String,
      default: ``,
    },
    values: {
      type: Array,
      default: () => [],
    },
    singleStat: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    widths () {
      if (this.singleStat) {
        // A single stat e.g. [tackles won, tackles attempted]
        const value = this.values[0];
        const total = this.values[1];
        if (total === 0) {
          return [50, 50];
        }
        const valueWidth = (value / total) * 100 <= 3 ? `3`
          : (value / total) * 100 >= 97 ? `97` : (value / total) * 100;
        return [valueWidth, 100 - valueWidth];
      }

      const total = this.values.reduce((a, b) => a + b, 0);
      if (total === 0) {
        return [50, 50];
      }

      // Get percentage width of each value
      // Give a min width (3%) and max width (97%) to each bar
      return this.values.map(value => (value / total) * 100 <= 3 ? `3`
        : (value / total) * 100 >= 97 ? `97` : (value / total) * 100);
    },
  },
};
